<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <div class="col-lg-11">
        <b-form @submit.stop.prevent="onSubmit">
          <b-row class="mb-5">
            <b-col sm="2">
              <label>
                <h5>
                  {{ $t("PAGE.USER.FORM.FIELDS.SANSOR") }}
                </h5>
              </label>
            </b-col>
            <b-col sm="10">
              <b-form-input id="email-input" name="email-input" type="text" v-model="$v.form.sensor_name.$model">
              </b-form-input>
            </b-col>
          </b-row>

          <b-row class="mb-5">
            <b-col sm="2">
              <label>
                <h5>
                  {{ $t("PAGE.USER.FORM.FIELDS.IP") }}
                </h5>
              </label>
            </b-col>
            <b-col sm="10">
              <b-form-input id="email-input" name="email-input" type="text" v-model="$v.form.api_url.$model">
              </b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-button type="submit" variant="primary" class="float-right mr-3">{{
                  $t("PAGE.DEFAULT.FORM.BTN_SUBMIT")
              }}</b-button>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<style>
.imgSize {
  margin-left: 30%;
  padding-top: 0.5cm;
  width: 30%;
  height: 30%;
  padding-bottom: 0.5cm;
}
</style>
<script>
import { IOT_CREATE_DATA, PUT_IOT_DATA, GET_IOT_DATA } from "@/core/services/store/iot.module";
import Swal from "sweetalert2";
export default {
  components: {

  },

  data() {
    return {
      mangrove_location_id:0,
      id: 0,
      form: {
        sensor_name: "",
        api_url: ""
      },
    };
  },
  validations: {
    form: {
      sensor_name: {},
      api_url: {}
    }
  },
  computed: {

  },
  mounted() {
    this.mangrove_location_id = this.$route.params.id

    if (this.mangrove_location_id > 0) {
      this.getUser(this.mangrove_location_id);
    }

  },
  methods: {
    getUser(id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(GET_IOT_DATA, { id })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                this.id=data.data.id
                for (const formKey of Object.keys(this.form)) {
                  for (const dataKey of Object.keys(data.data)) {
                    if (formKey === dataKey) {
                      this.form[formKey] = data.data[formKey];
                    }
                  }
                }
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    onSubmit() {
      let formData = new FormData();
      let id = this.id
      formData.append("mangrove_location_id",this.$store.state.mangrove_location.data_pram.mangrove_location_id );
      formData.append("sensor_name", this.form.sensor_name);
      formData.append("api_url", this.form.api_url);
      if (this.id > 0) {
        this.update(id, formData)
      } else {
        this.create(formData);
      }

    },
    update(id, data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(PUT_IOT_DATA, { id, data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },

    create(data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(IOT_CREATE_DATA, { data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                this.mangrove_location_id = data.data.mangrove_location_id
                this.id=data.data.id
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE.SUCCESS_TO_SAVE_DATA")}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  }
};
</script>
